(function () {
  'use strict';

  angular.module('app').component('bookingStatusLabel', bookingStatusLabel());

  function bookingStatusLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: BookingStatusLabelComponent,
      controllerAs: 'vm',
      template:
        '<span class="status-label text-{{ vm.statusClass }}">' +
        '<i class="fa fa-circle"></i> {{ vm.statusTitle }}' +
        '</span>',
    };
  }

  BookingStatusLabelComponent.$inject = ['$translate'];

  function BookingStatusLabelComponent($translate) {
    const vm = this;

    vm.$onChanges = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      let statusClass;
      let statusIcon;
      let statusTitle;

      switch (vm.status) {
        case 'oncart':
          statusClass = 'warning';
          statusIcon = 'shopping-cart';
          statusTitle = 'ONCART';
          break;
        case 'draft':
          statusClass = 'default';
          statusIcon = 'eraser';
          statusTitle = 'DRAFT';
          break;
        case 'processing':
          statusClass = 'primary';
          statusIcon = 'spinner';
          statusTitle = 'PROCESSING';
          break;
        case 'confirmed':
          statusClass = 'success';
          statusIcon = 'check';
          statusTitle = 'CONFIRMED';
          break;
        case 'cancelled':
          statusClass = 'danger';
          statusIcon = 'times';
          statusTitle = 'CANCELLED';
          break;
        case 'closed':
          statusClass = 'inverse';
          statusIcon = 'archive';
          statusTitle = 'CLOSED';
          break;
      }

      vm.statusClass = statusClass;
      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
